@if (showLoader()) {
  <wpp-piston-loader size="15rem" centered />
} @else if (dealerIdMissing()) {
  <main class="missing-dealer-id">
    <div class="missing-dealer-id__card">
      <h1 class="missing-dealer-id__title">{{ 'wpp.app.invalid-url.title' | translate }}</h1>
      <p class="missing-dealer-id__body">{{ 'wpp.app.invalid-url.body' | translate }}</p>
    </div>
  </main>
} @else {
  <router-outlet />
}

<wpp-server-error-modal />
